$            = require('jquery');
var angular  = require('angular');
var _module  = require('./index');
imagesLoaded = require('imagesloaded');

require('angular-animate');
require('slick-carousel');
require('angular-slick');
require('../lr-touch');
require('../cached-templates/templates');
require('./utils');

_module.requires.push('lr.touch', 'ngAnimate', 'templates');

_module.directive('fullscreenGallery', [
    '$rootScope',
    '$compile',
    '$templateCache',
    '$timeout',
    '$utils',

    function($rootScope, $compile, $templateCache, $timeout, $utils) {
        var IMAGES_LOADING_EVENT          = 'fullscreenGalleryImages:imagesLoading';
        var IMAGES_LOADING_COMPLETE_EVENT = 'fullscreenGalleryImages:imagesLoadingComplete';
        var TEMPLATE                      = $templateCache.get('js/components/core/templates/fullscreen-gallery.tmpl.html');

        return {
            restrict: 'AE',
            scope: {
                '$images': '=images',
                '$currentIndex': '=currentIndex',
                '$show': '=show'
            },
            link: function($scope, elem, attrs) {
                var html = $compile(TEMPLATE)($scope);

                $scope.maxWidth     = $(window).width();
                $scope.maxHeight    = $(window).height();
                $scope.currentIndex = 0;
                $scope.showArrows   = !$utils.hasTouchSupprt();
                $scope.imageStyles  = {
                    maxWidth: $scope.maxWidth + 'px',
                    maxHeight: $scope.maxHeight + 'px'
                };

                $('body').append(html);

                $(window).on('resize', function() {
                    $timeout(function() {
                        $scope.maxWidth  = $(window).width();
                        $scope.maxHeight = $(window).height();
                    });
                });

                $scope.$close = function() {
                    $scope.$show = false;
                };

                $scope.afterChange = function(index) {
                    $timeout(function() {
                        console.log('Set Index');
                        $scope.$currentIndex = index;
                    });
                };
            }
        };
    }
]);
